import { render, staticRenderFns } from "./table.vue?vue&type=template&id=fa0fbf0a"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa0fbf0a')) {
      api.createRecord('fa0fbf0a', component.options)
    } else {
      api.reload('fa0fbf0a', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=fa0fbf0a", function () {
      api.rerender('fa0fbf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/import/table.vue"
export default component.exports